"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Flow extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Creates a new flow on the given reference. Only valid reference is "app".
     * @param ref_type
     * @param ref_id
     * @returns
     */
    add(ref_type, ref_id, attribute) {
        const requestObj = {
            method: 'post',
            url: `/flow/${ref_type}/${ref_id}/`,
            data: attribute,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Delete the flow with the given id.
     * @param flow_id
     * @returns
     */
    delete(flow_id) {
        const requestObj = {
            method: 'delete',
            url: `/flow/${flow_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get's the effect attributes for the effect
     * @param ref_type
     * @param ref_id
     * @returns
     */
    getEffectAttributes(ref_type, ref_id, attributes) {
        const requestObj = {
            method: 'post',
            url: `/flow/${ref_type}/${ref_id}/effect/attributes/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the flow with the given id.
     * @param flow_id
     * @returns
     */
    get(flow_id) {
        const requestObj = {
            method: 'get',
            url: `/flow/${flow_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the possible attributes on the given flow.
     * @param flow_id
     * @returns
     */
    getContext(flow_id) {
        const requestObj = {
            method: 'get',
            url: `/flow/${flow_id}/context/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get all the flows on the given ref
     * @param ref_type
     * @param ref_id
     * @returns
     */
    getAll(ref_type, ref_id) {
        const requestObj = {
            method: 'get',
            url: `/flow/${ref_type}/${ref_id}/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get's the possible attributes to use as variables for a given effect attribute.
     * @param ref_type
     * @param ref_id
     * @param attributes
     * @returns
     */
    getPossibleAttributes(ref_type, ref_id, attributes) {
        const requestObj = {
            method: 'post',
            url: `/flow/${ref_type}/${ref_id}/attributes/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Updates the flow. The type cannot be changed.
     * @param flow_id
     * @param attribute
     * @returns
     */
    update(flow_id, attribute) {
        const requestObj = {
            method: 'put',
            url: `/flow/${flow_id}`,
            data: attribute,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Flow;
